export default __webpack_public_path__ + "static/media/Kyoko_Jansson_AHV_In_Moms_We_Trust.78dc4334.jpg";